import styles from './MultipleSelectBar.module.css'
import { MultipleSelectBarProps } from './MultipleSelectBar.types'

export const MultipleSelectBar = ({ actions, message, dataTestId }: MultipleSelectBarProps) => (
  <div className={styles.container} data-testid={dataTestId}>
    {message}
    <div className={styles.actions}>{actions}</div>
  </div>
)
